export const ResearchExperienceList = [
    {
      title: "DEVELOPING MARKETPLACE WEBSITE FOR BUYING AND SELLING FRANCHISE BUSINESS",
      position: "Software Engineer",
      duration: "February 2025 - January 2026",
      responsibilities: [
        `Engineered an advanced search system leveraging LLM Embedded Text and Image Vector Search using Elasticsearch, maintaining a consistent 130ms average latency across complex multi-parameter queries.`,
        `Implemented Google Maps API to map existing franchise locations across the region in Indonesia, improving geospatial data visualization.`,
        `Integrated the Midtrans payment gateway to streamline transactions, ensuring secure and efficient payment processing.`,
        `Orchestrated the deployment of containerized services from Docker Compose to Google Kubernetes Engine (GKE) on Google Cloud Platform (GCP).`
      ],
    },
  ];
  